import { render } from "./Dropdown1.vue?vue&type=template&id=7a8f53eb&ts=true"
import script from "./Dropdown1.vue?vue&type=script&lang=ts"
export * from "./Dropdown1.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\kevintam\\Documents\\pokeraudit\\pokeraudit\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__